// PACKAGE DEPENDENCIES
import React from 'react';
import ReactDOM from 'react-dom';

// COMPONENTS

import App from './components/App';

// STYLES

import 'normalize.css';
import './styles/app.scss';

ReactDOM.render(<App />, document.getElementById('app'));